import { memo } from 'react';

export const Page404 = memo(() => {
  return (
    <div>
      <h1>ページが見つかりません</h1>
    </div>
  );
});
